<template>
<div class="adv-order-transporters">
  <div v-if="getTransporters.length > 0" class="adv-order-transporters">
    <AdvOrderTransportersSingle v-if="getTransporters.length === 1" />
    <AdvOrderTransportersMultiple
      v-else
      v-on:set-input="$emit('set-input', $event)"
      v-on:input="$emit('input', $event)"
      v-on:change="$emit('change', $event)"
    />
  </div>
</div>

</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import AdvOrderTransportersSingle from './AdvOrderTransportersSingle.vue'
import AdvOrderTransportersMultiple from './AdvOrderTransportersMultiple.vue'

export default {
  name: 'AdvOrderTransporters',
  components: {
    AdvOrderTransportersMultiple,
    AdvOrderTransportersSingle
  },
  props: {
    country: { type: String, default: '' },
    county: { type: String, default: '' },
    postal: { type: String, default: '' }
  },
  watch: {
    country (val) {
      this.initTransporters()
      this.setSmartPointIsSelected(false)
      this.setSelectedSmartPoint(null)
    },
    county (val) {
      this.initTransporters()
    },
    postal (val) {
      this.initTransporters()
    },
    cartTotalWithDiscount (val) {
      this.initTransporters()
    },
    cartProductWeightTotal (val) {
      this.initTransporters()
    }
  },
  computed: {
    ...mapGetters([
      'getTransporters',
      'cartTotalWithDiscount',
      'cartProductWeightTotal'
    ])
  },
  mounted () {
    if (this.country && this.county && this.postal) {
      this.initTransporters()
    }
  },
  methods: {
    ...mapActions([
      'getTransporterData',
      'setSelectedSmartPoint'
    ]),
    ...mapMutations([
      'setSmartPointIsSelected'
    ]),
    initTransporters () {
      this.getTransporterData({
        country: this.country,
        county: this.county,
        postal: this.postal,
        totalWithVat: this.cartTotalWithDiscount,
        weight: this.cartProductWeightTotal
      })
    }
  }
}
</script>
